import React, { FC } from "react";
import { useDialogReset } from "../../../hooks/useDialogs";
import { StyledDialog } from "../DialogComponents/styled";

import { NewLayerProvider } from "./newLayerContext";
import { NewLayerSteps } from "./NewLayerSteps";

export const NewLayer: FC = () => {
  const closeDialog = useDialogReset();

  return (
    <StyledDialog
      isOpen
      modal
      onCloseRequest={closeDialog}
      minWidth={"58rem"}
      maxWidth={"58rem"}
      minHeight={"calc(100% - 6rem)"}
    >
      <NewLayerProvider>
        <NewLayerSteps />
      </NewLayerProvider>
    </StyledDialog>
  );
};
